import BaseListPresenter from "../../base/BaseListPresenter";

class AccountingCalendarPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  init() {
    this.limit = 100; // Increased limit to fetch more employees at once
    this.where = { status: "For Last Pay", lastPayDate: { $exists: true } };
    this.search = {};
    this.filter = {};
    this.include = [];
    this.keys = undefined;
    this.sort = { lastPayDate: 1 }; // Sort by lastPayDate for better organization
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async getLastPayEmployees() {
    const collection = "employees";

    try {
      console.log("Fetching employees with Last Pay status and lastPayDate");

      // Create a query to filter employees with Last Pay status and lastPayDate
      const query = {
        where: {
          status: "For Last Pay",
          lastPayDate: { $exists: true },
        },
        sort: { lastPayDate: 1 },
        timestamp: Date.now(), // Add this to ensure fresh data
      };

      console.log("Query for employees:", JSON.stringify(query));
      const employees = await this.findObjectUseCase.execute(collection, query);
      console.log("Employees retrieved:", employees?.length || 0);

      if (!employees) {
        console.warn("No employees found or undefined response");
        return [];
      }

      if (!Array.isArray(employees)) {
        console.warn("Employees is not an array, converting to array format");
        return typeof employees === "object" ? [employees] : [];
      }

      return employees;
    } catch (error) {
      console.error("Error fetching employees with Last Pay status:", error);
      return [];
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }
}

export default AccountingCalendarPresenter;
